import { render, staticRenderFns } from "./ModalProjectGroupAdd.vue?vue&type=template&id=e0d89336&lang=pug"
import script from "./ModalProjectGroupAdd.vue?vue&type=script&lang=js"
export * from "./ModalProjectGroupAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports